import { render, staticRenderFns } from "./SelectVideoDialog.vue?vue&type=template&id=1dff9fd0&scoped=true"
import script from "./SelectVideoDialog.vue?vue&type=script&lang=js"
export * from "./SelectVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectVideoDialog.vue?vue&type=style&index=0&id=1dff9fd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dff9fd0",
  null
  
)

export default component.exports